import { GetBookingDetailsResponse } from "modules/BookingCommon/common/interfaces"
import { isObject } from "utils/utils"

const interfaceKeys = [
    "booking_id",
    "status",
    "cancelled",
    "client_name",
    "client_email",
    "client_phone",
    "client_id",
    "psy_full_name",
    "psy_phone",
    "psy_profile_url",
    "rfc3339_start_datetime",
    "start_datetime_client_tz",
    "client_tz",
    "is_online",
    "address",
    "price",
    "price_usd",
    "psy",
    "service_type",
    "service_description",
    "payment_system",
    "is_free",
    "discounted",
    "short_url",
    "is_initial",
    "sequence_number",
    "is_available_for_call",
] as const

export function isGetBookingDetailsResponse(data: unknown): data is GetBookingDetailsResponse {
    return isObject(data) && interfaceKeys.every((key) => key in data)
}
